import { Controller } from "@hotwired/stimulus";

// Opens a <dialog> that lives elsewhere in the DOM (outside this element's
// own subtree) by id — e.g. the "Desfazer" link in "Últimos eventos" opening
// the técnico/presidente/supervisor card modal declared further down in
// games/_live_game_card.html.erb, so releasing several cards goes through
// one checkbox-based dialog instead of one-at-a-time destroys.
export default class extends Controller {
  static values = { id: String };

  open() {
    document.getElementById(this.idValue)?.showModal();
  }
}
